import { 
  Component, 
  OnInit, 
  OnDestroy,
  ViewChild,
  ElementRef,
  ChangeDetectorRef } from '@angular/core';
import { GithubService } from '../services/github.service';
import { Router, NavigationStart } from '@angular/router';
import { UserdataService } from '../services/userdata.service';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';
import { StripeService } from '../services/stripe.service';
import { NgForm } from '@angular/forms';
import { WindowRefService, ICustomWindow } from '../services/window.service';
import * as LogRocket from 'logrocket';
import { Http } from '@angular/http';

declare var Stripe:any;

@Component({
  selector: 'app-deploy',
  templateUrl: './deploy.component.html',
  styleUrls: ['./deploy.component.css']
})
export class DeployComponent implements OnInit, OnDestroy {

  salePrice = 1499;
  location = "deploy";
	stripeDescription: string;
	handler: any;
	user: any;
  userData: any;
  userSecureData: any = null;
  stripe: any = null;
  cardElement: any = null;
  intent: any = null;
  voucherCode: string = "";
  checkingVoucherCode: boolean = false;
  voucherMessage: string = "";
  voucherDiscount: number = null;
  view = {
    'voucherInput': false,
    'voucherApplied': false,
    'showCardInput': false,
    'paymentError': null,
    'checkoutLoading': false,
    'checkingGithub': false,
    'githubDeployStatus': "",
    'loadingStripe': false,
    'cardError': ""
  };
  deployRepo: any; // used for selecting what repo we want to deploy the code to on Github;
  MDPuserPrevious: any;
  cardHandler = this.onChange.bind(this);
  @ViewChild('cardElementDiv') cardInfo: ElementRef;
  private _window: ICustomWindow;

  constructor(
  		private github: GithubService,
	  	private userDataService: UserdataService,
      private authService: AuthService,
	  	private router: Router,
      private StripeService: StripeService,
      private cd: ChangeDetectorRef,
      private http: Http,
      windowRef: WindowRefService) {
        // get reference to window
        this._window = windowRef.nativeWindow
      }
  ngOnInit() {

    // get currently authed user
    this.authService.getAuthState()
      .subscribe((user) => {

        if(!user) {
          console.log("no user, nav to home");
          this.router.navigate(["/"])
        } else {

          this.user = user
          // console.log("user is authed:", this.user);

          // get userData
          this.userDataService.getData()
            .subscribe(data => {
              this.userData = data;
              console.log('deploy userData udpated:', this.userData)

              if(!this.deployRepo){
                // make this the default login name if not set already
                let defaultRepo = this.userData.publicGithubRepos.find(repo=>{
                  return repo.name.toLowerCase() == this.userData.login.toLowerCase()+".github.io";
                })

                // if they don't have a main site, select the first repo
                if(!defaultRepo) defaultRepo = this.userData.publicGithubRepos[0]
                
                this.deployRepo = defaultRepo;
              }
            })
          
          // get secure data
          this.userDataService.getSecureData()
            .subscribe(data => {
              this.userSecureData = data;
              console.log('Secure data updated:', this.userSecureData)
            })
        }

      });

    // init Stripe
    this.stripe = Stripe(environment.stripeKey);

    setTimeout(() => {
      this.showCardInput();
    }, 1000);

  }

  ngOnDestroy() {
    // clean up our mess
    if(this.cardElement){
      this.cardElement.removeEventListener('change', this.cardHandler);
      this.cardElement.destroy();
    }
  }

  // used for changes to stripe payment form
  onChange({ error }) {
    if (error) {
      this.view.cardError = error.message;
    } else {
      this.view.cardError = null;
    }
    this.cd.detectChanges();
  }

  async onSubmit(form: NgForm) {

    console.log('onSubmit: submitting form, this.userData:', this.userData)

    if (this.view.cardError) {return}

    this.view.loadingStripe = true

    this.createPayment()

  }



  async initSubscription () {
    /* 
      User wants to start the process of upgrading
      we'll create a customer
      then capture the payment method
      then create the subscription
    */

    // track in SA
    if(this._window.sa_event){
      this._window.sa_event("initiate-subscription");
    }

    // show a loader
    this.view.loadingStripe = true

    // if the user doesn't have a stripeId, create one
    let stripeId;
    try {
      stripeId = this.userData.stripeInfo.stripeId
    } catch (error) {

      let stripeCustomer = await this.StripeService.createCustomer(this.userData, this.userDataService.getUserId());

      if(stripeCustomer.errorMessage){
        alert("Dang, something went wrong")
        console.log("error creating customer:", stripeCustomer.errorMessage);
        return
      }

      stripeId = stripeCustomer.id

    }

    // hide loader for now
    this.view.loadingStripe = false

    // init the elements, the form submit function takes over from here
    this.view.showCardInput = true;
    var elements = this.stripe.elements();
    this.cardElement = elements.create('card');
    this.cardElement.mount('#card-element');
    this.cardElement.addEventListener('change', this.cardHandler);

  }

  /*
    To account for
      - managing payment authentication
      - managing subscription payment failure
      - cancelling subscription
  */

  async createSubscription(customerId, paymentMethodId){
    // Step 6: https://stripe.com/docs/billing/subscriptions/fixed-price#create-subscription

    LogRocket.track('subscription-attempt')

    console.log("creating subscription")

    this.view.loadingStripe = true

    let subscription = await this.StripeService.createSubscription(this.userDataService.getUserId(), customerId, paymentMethodId);

    if(subscription.errorMessage){
      this.view.cardError = subscription.errorMessage
    } else {
      console.log('subscription created:', subscription)
      if (subscription.latest_invoice.payment_intent.status == 'requires_action'){
        let obj = {
          paymentMethodId: paymentMethodId,
          subscription: subscription,
          invoice: null,
          priceId: null,
          isRetry: null
        }

        let result = await this.handlePaymentThatRequiresCustomerAction(obj);
        
        console.log("requires action result:", result)
        
        if (result.error) { 
          console.log('err handling payment:', result.error); 

        } else {
          // everything's good, apparently
          // webhook should happen and UI update automatically
          // perhaps we display a popup modal or something to say thanks though 
          
          // track in SA
          if(this._window.sa_event){
            this._window.sa_event("subscription-started");
          }

          LogRocket.track('subscription-success')

        }

      }
    }

    this.view.loadingStripe = false

  }

  async handlePaymentThatRequiresCustomerAction({
    subscription,
    invoice,
    priceId,
    paymentMethodId,
    isRetry,
  }) {
    if (subscription && subscription.status === 'active') {
      // Subscription is active, no customer actions required.
      return { subscription, priceId, paymentMethodId };
    }

    // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
    // If it's a retry, the payment intent will be on the invoice itself.
    let paymentIntent = invoice ? invoice.payment_intent : subscription.latest_invoice.payment_intent;

    if (
      paymentIntent.status === 'requires_action' ||
      (isRetry === true && paymentIntent.status === 'requires_payment_method')
    ) {
      return this.stripe
        .confirmCardPayment(paymentIntent.client_secret, {
          payment_method: paymentMethodId,
        })
        .then((result) => {
          if (result.error) {
            // Start code flow to handle updating the payment details.
            // Display error message in your UI.
            // The card was declined (i.e. insufficient funds, card has expired, etc).
            throw result;
          } else {
            if (result.paymentIntent.status === 'succeeded') {
              // Show a success message to your customer.
              // There's a risk of the customer closing the window before the callback.
              // We recommend setting up webhook endpoints later in this guide.
              return {
                priceId: priceId,
                subscription: subscription,
                invoice: invoice,
                paymentMethodId: paymentMethodId,
              };
            }
          }
        })
        .catch((error) => {
          return {
            error: error
          }
        });
    } else {
      // No customer action needed.
      return { subscription, priceId, paymentMethodId };
    }
  }

	downloadCode() {

		// user wants to download the code to host somewhere themselves

    // track in SA
    if(this._window.sa_event){
      this._window.sa_event("download-code");
    }

    LogRocket.track('download-code');
    
    // download the code..
    this.downloadHtml();

  }

  async deployCode() {

    console.log('user wants to deploy code to their Github:', this.deployRepo.name)

    // track in SA
    if(this._window.sa_event){
      this._window.sa_event("deploy-code-to-github");
    }

    LogRocket.track('deploy-code-to-github');

    let obj = {
      user: this.userData.login,
      repo: this.deployRepo.name,
      page: this.userData.portfolio.page,
      token: this.userData.token
    }

    // we need to check the commit for index.html and a .nojekyll file
    // if either of them are empty we need to create them

    // get the current commit object for index.html
    this.view.githubDeployStatus = "Checking for index.html file"
    let indexFileContents = null;

    await this.checkForJeckyllFile()

    try {
      indexFileContents = await this.github.getFileContents( this.userData.login, this.deployRepo.name, this.userData.token, "index.html")

    } catch (e) {

      if(e.status === 404){
        // no index.html, fine
        console.log("no index file, that's fine")
      }
    }

    // try updating index.html
    try {
      console.log("attempting index.html update")
      this.view.githubDeployStatus = "Updating index.html..."

      let updateObj = {
        "message": `commit from mydevportfolio at ${new Date()}`,
        "content": btoa(obj.page),
        "sha": indexFileContents ? indexFileContents.sha : ""
      }
  
      let resp = await this.github.updateFileContents(this.userData.login, this.deployRepo.name, this.userData.token, updateObj, "index.html").toPromise()

      console.log('resp:', resp);
      
      this.view.githubDeployStatus = "index.html updated!"
    } catch (error) {
      // alert("err updating index.html: "+error)
      this.view.githubDeployStatus = "error: "+error
    }

  }

  async checkForJeckyllFile(){
    let jeckyllFIle;
    try {
      jeckyllFIle = await this.github.getFileContents(this.userData.login, this.deployRepo.name, this.userData.token, ".nojekyll")

    } catch (e) {

      if(e.status === 404){
        // no index.html, fine
        console.log("no .nojekyll file, create one")
        // try updating index.html
        try {
          console.log("attempting .nojekyll file creation")

          let updateObj = {
            "message": `commit from mydevportfolio at ${new Date()}`,
            "content": btoa("")
          }

          let resp = await this.github.updateFileContents(this.userData.login, this.deployRepo.name, this.userData.token, updateObj, ".nojekyll").toPromise()

          console.log('resp:', resp);

          this.view.githubDeployStatus = "added .nojekyll file :) "
        } catch (error) {
          // alert("err updating index.html: "+error)
          this.view.githubDeployStatus = "error: "+error
        }
      }
    }
  }

  selectDeployRepo(repo){
    console.log("deployRepo:", repo);
    this.deployRepo = repo;
  }

  getUserPublicRepos(GHusername){
    this.view.checkingGithub = true
    this.github.getReposForUser(GHusername)
      .subscribe(data => {
        // console.log('user public repos:', data);
        this.userData.publicGithubRepos = data;

        this.userData.lastCheckedGithub = new Date();

        // update database
        this.saveData();

        this.view.checkingGithub = false
      })
  }

  saveData(){

    // check MDPuserPrevious, if there's no difference then don't send request
    if(JSON.stringify(this.userData) === JSON.stringify(this.MDPuserPrevious)){
      // no change, don't send request
      console.log('no change, cancelling...')
      return
    }

    // there must have been a change
    // set previous object now
    this.MDPuserPrevious = JSON.parse(JSON.stringify(this.userData));

    // save data
    this.userDataService.saveData(this.userData);

  }

  downloadHtml(){

    let analyticsLabel;

    if(this.voucherCode){
      analyticsLabel = 'site-download-voucher:'+this.voucherCode;
    } else {
      analyticsLabel = 'site-download'
    }

    // track in SA
    if(this._window.sa_event){
      this._window.sa_event(analyticsLabel);
    }

  	var dataStr = "data:text/html;charset=utf-8," + encodeURIComponent(this.userData.portfolio.page);
  	var dlAnchorElem = document.getElementById('downloadAnchorElem');
  	dlAnchorElem.setAttribute("href", dataStr );
  	dlAnchorElem.setAttribute("download", "index.html")
  	dlAnchorElem.click();

  }

  showCardInput() {
    console.log("showing card input, salePrice:", this.salePrice);
    if(this.salePrice === 0){
      console.log('user has voucher for FREE download')
      this.downloadHtml();
      return
    }
    this.view.showCardInput = true;
    var elements = this.stripe.elements();
    
    // this.cardElement = elements.create('card', {
    //   style: {
    //     base: {
    //       color: '#ggg',
    //       fontWeight: 600,
    //     }
    //   }
    // });

    this.cardElement = elements.create('cardNumber', {});
    this.cardElement.mount('#stripe-card-number');

    var cardExpiry = elements.create('cardExpiry', {});
    cardExpiry.mount('#stripe-card-expiry');

    var cardCvc = elements.create('cardCvc', {});
    cardCvc.mount('#stripe-card-cvc');

  }

  createPayment() {
    console.log("creating payment...");
    // clear any errors
    this.view.paymentError = null;
    this.view.checkoutLoading = true;
    this.stripe.createPaymentMethod('card', this.cardElement, {
      billing_details: {email: this.userData.email || "no email"}
    }).then(result => {
      if (result.error) {
        // Show error in payment form
        console.log("error:", result.error)
        this.view.paymentError = result.error.message;
        this.view.checkoutLoading = false
      } else {

        // no error, confirm the charge
        console.log("confirming charge, result:", result)
        this.confirmCharge(result)
      }
    });
  }

  confirmCharge(data) {
    console.log('confirming charge, data:', data);
    this.view.checkoutLoading = true;
    let requestBody = {}
    if(data.paymentMethod){
      requestBody = { 
        payment_method_id: data.paymentMethod.id, 
        amount: 1499,
        userId: this.userDataService.getUserId()
      }
    } else {
      requestBody = { 
        payment_intent_id: data.paymentIntent.id, 
        amount: 1499,
        userId: this.userDataService.getUserId()
      }
    }

    this.http.post(environment.apiUrl + "confirmcharge", requestBody)
      .subscribe(async res => {

          let data = await res.json()

          console.log('response:', data );

          this.handleServerResponse(data);
          this.view.checkoutLoading = false;
        },
        err => {
          console.error('error confirming charge:', err);
          // alert('something went wrong: ' + err)
          this.view.checkoutLoading = false;
        })
  }

  handleServerResponse(response) {
    console.log('handling server response:', response)
    this.view.checkoutLoading = true;
    if (response.error) {
      // Show error from server on payment form
      console.log("error:", response.error)
      this.view.paymentError = response.error.message
    } else if (response.requires_action) {
      // Use Stripe.js to handle required card action
      this.stripe.handleCardAction(
        response.payment_intent_client_secret
      ).then(result => {
        if (result.error) {
          // Show error in payment form
          console.log("error:", result.error)
          this.view.paymentError = result.error.message;
        } else {
          // The card action has been handled
          // The PaymentIntent can be confirmed again on the server
          // no error, confirm the charge
          this.confirmCharge(result)
        }
        this.view.checkoutLoading = false;
      });
    } else {
      // Show success message

      console.log("charge confirmed, waiting for secure account to be updated");


      this.view.checkoutLoading = false;

    }
  }


}



// WEBPACK FOOTER //
// ./src/app/deploy/deploy.component.ts